import styled, { css } from 'styled-components'
import { Row, Column } from '@sainsburys-tech/bolt'
import { AvailableIcon } from '@sainsburys-tech/bolt-icons'
import { colorToLunaToken } from '../../../../helpers/theming/utilities'
import { themeContract } from '../M023.theme.contract'

const SuccessMargin = styled(Column)`
  display: flex;
  margin-top: 10px;
  margin-bottom: 0;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    margin-bottom: 10px;
  }
`

const WrapperBenefit = styled.div`
  border: none;
  min-width: 100%;
  min-height: auto;
  padding-right: ${(props) => props.theme.size.spacing.lg};
`

const TextContainer = styled(Row)`
  flex-direction: row;
`

const BenefitsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].background.color]};
  border-radius: ${(props) => props.theme.size.border.radius.base};
  align-items: baseline;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    flex-direction: row;
    text-align: center;
  }
`

const BenefitsSvg = styled(AvailableIcon)`
  ${(props) =>
    css`
      fill: ${colorToLunaToken(props.iconColor, props.theme) === null
        ? props.theme.color.palette[themeContract[props.theme.channel].benefitsIconColor.color]
        : colorToLunaToken(props.iconColor, props.theme)};
    `}
  min-width: 24px;
  height: 24px;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    width: 100%;
  }
`

const BenefitsText = styled.p`
  padding-left: ${(props) => props.theme.size.spacing.lg};
  margin-bottom: 0;
  color: ${(props) => props.theme.color.monochrome.darker};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    text-align: center;
    padding-left: 0;
    width: 100%;
  }
`

export { SuccessMargin, TextContainer, WrapperBenefit, BenefitsWrapper, BenefitsSvg, BenefitsText }
